import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton } from '@mui/material';
import { useState } from 'react';
import { CopyLinkButton } from 'components';
import { ServiceType } from 'shared/constants/service';
import ShareIssueButton from 'components/ShareIssueButton';
import DeleteIssueButton from '../DeleteIssueButton';
import PropTypes from 'prop-types';
import logger from 'utils/logger';
import { doesUserHaveSeimitsuIssueDeletionPrivilege } from 'utils/privilege';
import { zIndexValues } from 'utils/styles';

const propTypes = {
  setIssueShareConfirmModalOpen: PropTypes.func.isRequired,
  shareIssueConfirmModalBodyText: PropTypes.object.isRequired,
  shareIssueConfirmFunc: PropTypes.object.isRequired,
  shareIssueCancelFunc: PropTypes.object.isRequired,
  shareIssueServiceType: PropTypes.string.isRequired,
  canDeleteIssue: PropTypes.bool.isRequired,
  setIssueDeleteConfirmModalOpen: PropTypes.func.isRequired,
};

const log = logger.createLogger('IssueOptionsMenu');

const IssueOptionsMenu = ({
  setIssueShareConfirmModalOpen,
  shareIssueConfirmModalBodyText,
  shareIssueConfirmFunc,
  shareIssueCancelFunc,
  shareIssueServiceType,
  canDeleteIssue,
  setIssueDeleteConfirmModalOpen,
}) => {
  // Add these state variables near the other useState declarations
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const shouldShowDeleteIssueButton =
    doesUserHaveSeimitsuIssueDeletionPrivilege();

  // Add this handler function near the other handlers
  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        onClick={handleMenuClick}
        aria-label="more options"
        aria-controls={open ? 'share-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="share-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
        sx={{ zIndex: zIndexValues.modalMenu }}
        aria-labelledby="more-button">
        <MenuItem>
          <ShareIssueButton
            setIssueShareConfirmModalOpen={(status) => {
              setIssueShareConfirmModalOpen(status);
              handleMenuClose();
            }}
            shareIssueConfirmModalBodyText={shareIssueConfirmModalBodyText}
            shareIssueConfirmFunc={shareIssueConfirmFunc}
            shareIssueCancelFunc={shareIssueCancelFunc}
            shareIssueServiceType={shareIssueServiceType}
          />
        </MenuItem>
        <MenuItem onClick={handleMenuClose}>
          <CopyLinkButton serviceType={ServiceType.SEIMITSU} />
        </MenuItem>
        {shouldShowDeleteIssueButton && canDeleteIssue && (
          <MenuItem onClick={handleMenuClose}>
            <DeleteIssueButton
              setIssueDeleteConfirmModalOpen={setIssueDeleteConfirmModalOpen}
            />
          </MenuItem>
        )}
      </Menu>
    </>
  );
};

IssueOptionsMenu.propTypes = propTypes;

export default IssueOptionsMenu;
